export const LEARN_DISCOUNT_BANNER_NAME = 'learndiscountbanner';

export const APP_INSTALL_BANNER_NAME = 'serpbanner';

export const LEARN_DISCOUNT_BANNER_SHOW_VALUE = 'DownloadApp';

export const APP_INSTALL_BANNER_SHOW_VALUE = 'DownloadApp-TH-banner';

export const APP_INSTALL_BANNER_CLICK_VALUE = 'DownloadApp-TH-banner_Установите приложение';
